// extracted by mini-css-extract-plugin
export default {"card":"JOk6RCej","title":"Uwnj5kj3","flexWrapper":"tgk3vkDe","flexBlock":"hcTqR0jn","button":"ZiBjIqxv"};
    if(module.hot) {
      // 1738090062000
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  